import { Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { FormService } from "../../services/form.service";

@Component({
    selector: 'app-moving-to',
    templateUrl: './moving-to.component.html',
    styleUrls: ['./moving-to.component.scss']
})
export class MovingToComponent implements OnInit {

	movingTo !: UntypedFormGroup
	formGroupName : string = 'movingTo'
	postcodeEnabled = true;

	labelAddress: string = '';
	labelPostcode: string = '';
	fieldOrder: any = [];
	countryFirst = false;
	enableFields = false;

    constructor(public formService: FormService, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {

        // Set moving to
        this.movingTo = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;

	    this.labelAddress = this.formService.getVariationTranslation( 'label-address');
	    this.labelPostcode = this.formService.getVariationTranslation( 'label-postcode');
		this.fieldOrder = this.formService.getFieldOrder( 'movingTo' );

	    // Decide order based on domainData
	    this.countryFirst = this.formService.domainData?.countryFirst;

		// Initial check
		this.onCountryChange();

	    this.formService.stepChange$.subscribe( currentFormGroupName => {

			// This enables the fields in the current step
			this.enableFields = currentFormGroupName === this.formGroupName;
	    } );
    }

    ngAfterViewInit() {

        // After view has loaded
    }

    onSubmit() {

        this.formService.submitFormGroup( (<UntypedFormGroup>this.movingTo) );
    }

	onCountryChange() {

		var selectedCountry = this.movingTo.controls['country'].value;
		// Ireland, Qatar, United-arab-emirates, Hong kong, Curacao
		// Aruba, Cameroon, Ghana, Suriname, Sint maarten
		var excludedCountries = ['IE', 'QA', 'AE', 'HK', 'CW', 'AW', 'CM', 'GH', 'SR', 'SX'];
		var postcodeControl = (<UntypedFormGroup>this.movingTo).controls['postcode'];

		// If the country is one of the excluded countries
		if( excludedCountries.includes( selectedCountry ) ) {

			// Postcode is never required on MovingTo

			// Reset value
			postcodeControl.reset();

			// Change the field order
			this.fieldOrder = ['address','city','postcode'];

			// Hide the postcode field
			this.postcodeEnabled = false;
		}
		else {

			// Reset field order
			this.fieldOrder = this.formService.getFieldOrder( 'movingTo' );

			// Show the field
			this.postcodeEnabled = true;
		}

		console.log( 'attempt to get order from order by country to');

		this.fieldOrder = this.formService.getFieldOrderByCountry( selectedCountry, 'movingTo' );

		// Check if we can enable movingToExtended
		this.formService.checkToEnableMovingToExtended();
	}
}
